import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the searched applicants list key, so a debounced keystroke re-keys THIS match and not the
// page above it — which paints its skeleton at `pendingMs: 0` and would unmount the search box mid-word. The search
// box writes `q`/`p` to the URL, so the loader and the list read the ONE object built here. No component: nothing
// to code-split, nothing painted on a re-key. The page reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/account/integrations/$appId/applicants/_list')({
  loaderDeps: ({ search }) => ({ p: search.p, q: search.q }),
  context: ({ deps, params }) => ({
    appApplicantsQueryOptions: trpc.apps.getApplicants.queryOptions({
      appClientId: params.appId,
      search: { q: deps.q || undefined, p: deps.p },
    }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.appApplicantsQueryOptions).catch(noop)
  },
})
